var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"f-h",staticStyle:{"display":"flex","justify-content":"center"}},[(_vm.errMsg)?_c('el-empty',{attrs:{"description":_vm.errMsg}}):_c('hic-emr-info-panel',{attrs:{"op-no":_vm.opNo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }